
import { defineComponent } from 'vue'
import KanbanNavigation from '@/components/KanbanNavigation.vue'
import KanbanSider from '@/components/KanbanSider.vue'
import KanbanSiderMenu from '@/components/KanbanSiderMenu.vue'
import KanbanTaskListContainer from '@/components/KanbanTaskListContainer.vue'
import { getBoardByIdService } from '@/services/board'
import { BoardType } from '@/types/entities'
import { LocalUserDataType } from '@/types/misc'
import jwtDecode from 'jwt-decode'
import Cookies from 'js-cookie'
export default defineComponent({
  components: {
    KanbanNavigation,
    KanbanSider,
    KanbanSiderMenu,
    KanbanTaskListContainer
  },
  data () {
    return {
      siderState: false
    }
  },
  provide () {
    return {
      getBoardById: this.getBoardById
    }
  },
  inject: ['getRecentBoards'],
  mounted () {
    this.siderState = localStorage.getItem('kanbanSiderMenuState') === 'true'
  },
  beforeUnmount () {
    this.$store.commit('RESET_CURRENT_BOARD')
  },
  watch: {
    '$route.params.boardId': {
      handler: function (id) {
        if (id) {
          this.getBoardById(id)
        }
      },
      immediate: true
    }
  },
  methods: {
    setRecentBoard (board: BoardType) {
      try {
        const user = jwtDecode(Cookies.get('token')) as Record<string, string>
        const localUserData: Array<LocalUserDataType> = JSON.parse(localStorage.getItem('localUserData'))
        if (!localUserData) {
          localStorage.setItem(
            'localUserData',
            JSON.stringify([
              {
                user: user.email,
                recentBoards: [board]
              }
            ])
          )
          return
        }
        const userIndex = localUserData.findIndex((data) => data.user === user.email)
        if (userIndex === -1) {
          localStorage.setItem(
            'localUserData',
            JSON.stringify([
              ...localUserData,
              {
                user: user.email,
                recentBoards: [board]
              }
            ])
          )
          return
        }
        const currentUserRecentBoards = localUserData[userIndex].recentBoards

        if (currentUserRecentBoards.find((cb) => cb._id === board._id)) return

        if (currentUserRecentBoards.length === 4) currentUserRecentBoards.pop()
        currentUserRecentBoards.unshift(board)

        localUserData[userIndex].recentBoards = currentUserRecentBoards

        localStorage.setItem('localUserData', JSON.stringify(localUserData))
      } catch (error) {
        console.error(error)
      } finally {
      }
    },
    async getBoardById (id: string) {
      const res = await getBoardByIdService(id)
      if (!res.error) {
        this.$store.commit('SET_CURRENT_BOARD', res.data)
        if (!res.data.starred) {
          this.setRecentBoard({ _id: id, name: res.data.name, starred: res.data.starred })
          this.getRecentBoards()
        }
      }
    },
    toggleSider () {
      this.siderState = !this.siderState
      localStorage.setItem('kanbanSiderMenuState', this.siderState)
    }
  }
})
